import React from 'react';
import './list-footer.css'


const Listfootertext = (props) => {
    return ( 
        <li className='listt-footer'>{props.list}</li>
     );
}
 
export default Listfootertext;